import React, { useEffect,useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";
import { pdf  } from "@react-pdf/renderer";
import MyReportCoA from "component/utils/MyReportCoA";
import MyReportAll from "component/utils/MyReportCoA";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import ClosingByCoA from "component/akunting/master/closing-laba-rugi/ClosingByCoA";
import ClosingAll from "component/akunting/master/closing-laba-rugi/ClosingAll";

function ClosingLabaRugi() {
  const { user } = useAuth();
  const [loadingCoA, setLoadingCoA] = useState(false);

  useEffect(() => {
      document.title = "Green Hill Kemuning | Closing Laba Rugi";
      window.scrollTo(0, 0);
  }, []);

  const handleDownloadCoA = async ({ startDate, endDate, accountCode }) => {
    try {
      setLoadingCoA(true);
      const reg_desc = user?.company;
      const startDateObj = new Date(startDate);
      const formattedStartDate = `${String(startDateObj.getDate()).padStart(2, "0")}-${String(startDateObj.getMonth() + 1).padStart(2, "0")}-${startDateObj.getFullYear()}`;
      const endDateObj = new Date(endDate);
      const formattedEndDate = `${String(endDateObj.getDate()).padStart(2, "0")}-${String(endDateObj.getMonth() + 1).padStart(2, "0")}-${endDateObj.getFullYear()}`;

      const res = await axios.post(
        `${process.env.REACT_APP_API}/closingbycoa`,
        { reg_desc, dari: formattedStartDate, sampai: formattedEndDate, coa: accountCode }
      );

      const jsonData = res.data.data;
      showSuccess("Closing by CoA Berhasil!");
    } catch (err) {
      console.error("Gagal mengambil data CoA:", err);
      showError("Gagal mengambil data Chart of Account.");
    } finally {
      setLoadingCoA(false);
    }
  };

  const handleDownloadAll = async ({ mode, selectedDate }) => {
    try {
      setLoadingCoA(true);
      const reg_desc = user?.company;
      const dateObj = new Date(selectedDate);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, "0")}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${dateObj.getFullYear()}`;
      if (mode === "day") {
        const res = await axios.post(
          `${process.env.REACT_APP_API}/closingbyday`,
          { reg_desc, tanggal:formattedDate }
        );
        const jsonData = res.data.data;
        showSuccess("Closing All by Day Bersahasil!");
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_API}/closingbymonth`,
          { reg_desc, tanggal:formattedDate }
        );
        const jsonData = res.data.data;
        showSuccess("Closing All by Month Bersahasil!");
      }
    } catch (err) {
      console.error("Gagal mengambil data Closing All:", err);
      showError("Gagal mengambil data Closing Semua.");
    } finally {
      setLoadingCoA(false);
    }
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Closing Laba Rugi Management</h5>
                            </div>
                          </div>
                        </div> 
                        <ClosingByCoA
                          onDownload={(formData) => handleDownloadCoA(formData)}
                          onLoading={loadingCoA}
                        />
                        <ClosingAll
                          onDownload={(formData) => handleDownloadAll(formData)}
                          onLoading={loadingCoA}
                        />
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>    
    </div>
  );
}

export default ClosingLabaRugi;
